import { useParentInvoicesStore } from '~common/store';

export const parentInvoiceSelector = (state) => ({
  invoices: state.invoices,
  getParentInvoices: state.getParentInvoices,
});

export default useParentInvoicesStore;
